<template>
	<div
		class="tips-by-status-row items-center bg-white dark:bg-bs-dark-bg-over rounded-3xl mb-4 p-3 grid text-left gap-4"
	>
		<div class="">
			<div class="rounded-full mx-auto w-8 h-8 flag-holder overflow-hidden">
				<img
					:src="`/img/countries/${getFlag(country)}.svg`"
					:alt="`Country ${country} Flag`"
				/>
			</div>
			<span class="text-bs-gray-dark dark:text-white text-xs whitespace-nowrap time">{{formatDate(createdDate)}}</span>
		</div>
		<div>
			<div class="flex items-center">
				<h3 class="gradient-text text-3xl font-bold mr-1">{{ homeGoals }}</h3>
				<span
					class="text-sm block text-bs-gray-dark dark:text-white font-medium"
					>{{ homeTeam }}</span
				>
			</div>
			<div class="flex items-center">
				<h3 class="gradient-text text-3xl font-bold mr-1">{{ awayGoals }}</h3>
				<span
					class="text-sm block text-bs-gray-dark dark:text-white font-medium"
					>{{ awayTeam }}</span
				>
			</div>
		</div>
		<span
			class="text-base block text-bs-gray-dark dark:text-white font-medium competition"
			>{{ competition }}</span
		>
	
		<span :class="[`status-${status.toLowerCase()}`,'text-right']">
			<h3 class="value main-value font-semibold">{{formatCurrency(virtualEquityAfterTip)}}</h3>
			<h5 class="value text-xs whitespace-nowrap"><span class="">{{outcome.symbol}} </span> {{outcome.percent ? outcome.percent.toLocaleString('en-GB',{style:'percent'}) : ''}} </h5>
		</span>
		<span
			class="text-base block text-bs-gray-dark dark:text-white font-medium market"
			>
			<svg  viewBox="0 0 200 50" :class="['line-chart', `line-status-${status.toLowerCase()}`]">
				<g >
					<path :d="area" class="area" :fill="`url(#gradient-${status.toLowerCase()})`" />
					<path :d="line" fill="transparent" stroke-width="2" class="line"  stroke-linecap="round" />
					<circle r="4" :cx="circle.x - 2" :cy="circle.y - 2"   />
					
				</g>
				
				<defs>
					<linearGradient :id="`gradient-${status.toLowerCase()}`" x1="0" x2="0" y1="0" y2="1">
						<stop class="stop1" offset="3%"/>
						<stop class="stop2" offset="60%"  />
					</linearGradient>
				</defs>
			</svg>

			</span
		>
		<span class="font-bold text-2xl gradient-text handicap">{{
			handicap
		}}</span>
		<span class="font-bold text-2xl gradient-text handicap">{{
			formatCurrency(virtualTipAmount)
		}}</span>
		<span class="font-bold text-2xl gradient-text oddvalue">{{
			oddValue
		}}</span>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import flags from '../../assets/flags.json'
import {scaleTime, scaleLinear, extent, line, area} from 'd3'
import { addDays, isBefore, format } from 'date-fns';


export default {
	props: ['id','homeGoals', 'createdDate', 'awayGoals', 'homeTeam', 'awayTeam', 'country', 'competition', 'marketName', 'handicap', 'oddValue', 'status',
		"virtualTipAmount",
		"virtualEquityAfterTip"],
	computed: {
		...mapGetters(['tipsByDate','equityByDate','settings']),
		line: function(){
			if (this.equityByDate) {
				let x = this.x()
				let y = this.y()
				const lineFn = line()
					.x((d) => { return x(d.x); })
					.y((d) => { return y(d.y); });
				let d = addDays(new Date(this.createdDate),1)
				return lineFn(this.equityByDate.filter(item => isBefore(item.x, d)));
			} else {
				return ''
			}
		},
		area: function(){
			if (this.equityByDate) {
				let x = this.x()
				let y = this.y()
				const lineFn = area()
					.x((d) => { return x(d.x); })
					.y0(() => y(0))
					.y1((d) => { return y(d.y); });
				let d = addDays(new Date(this.createdDate),1)
				return lineFn(this.equityByDate.filter(item => isBefore(item.x, d)));
			} else {
				return ''
			}
		},
		outcome: function(){
			let bucket = this.equityByDate.find(d => d.tipsOutcome[this.id])
			let outcome =  bucket.tipsOutcome[this.id]
			return outcome
				
		},
		circle: function(){
			if (this.outcome){
				let x = this.x()
				let y = this.y()
				return { x: x(new Date(this.createdDate)), y: y(this.outcome.total)}
			} else {
				return {x:0,y:0}
			}
		}
		
	},

    methods: {
		x: function(){
			return scaleTime()
				.domain(extent(this.equityByDate, d => new Date(d.x)))
				.range([5, (180)])
		},
		y: function(){
			return scaleLinear()
			.domain(extent(this.equityByDate, d => d.y))
			.range([45, 10])
		},
		getFlag: function (country) {
			if (country && flags[country.toLowerCase()]) {
				return country.toLowerCase();
			} else {
				return 'globe';
			}
		},
		formatCurrency: function (n) {
			
			return (
				typeof n !== "undefined" &&
				n.toLocaleString('en-GB', {
					style: "currency",
					currency: this.settings.currencyCode || 'EUR',
					currencyDisplay: "symbol",
				})
			);
		},
		formatDate: function(str){
			return format(new Date(str), 'dd-MM-yyyy HH:mm')
		}
       
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/base.scss";
.time {font-size:0.6rem;}
.tips-by-status-row {
    grid-template-columns: 5rem 2fr 1fr 0.4fr 1fr 5rem 8rem 5rem;
    grid-template-rows:1fr;
}


.line-status-success  path.line {
  stroke: transparentize( $forest-green, 0.5);
  box-shadow: 0 8px 12px 0;
  
}
#gradient-success .stop1 {
	stop-color: transparentize( $forest-green, 0.8)
}
#gradient-success .stop2 {
	stop-color: transparentize( $forest-green, 1)
}
.line-status-halfwin  path.line {
  stroke:  transparentize( $forest-green-light, 0.5);
  
}
#gradient-halfwin .stop1 {
	stop-color: transparentize( $forest-green, 0.9)
}
#gradient-halfwin .stop2 {
	stop-color: transparentize( $forest-green, 1)
}
.line-status-void  path.line {
  stroke:  transparentize( $orange, 0.5);
  
}
#gradient-void .stop1 {
	stop-color: transparentize( $orange, 0.8)
}
#gradient-void .stop2 {
	stop-color: transparentize( $orange, 1)
}
.line-status-halfloss  path.line {
  stroke: $transparent-light-red;
  
}
#gradient-halfloss .stop1 {
	stop-color:  transparentize( $light-red, 0.5);
}
#gradient-halfloss .stop2 {
	stop-color: transparentize( $light-red, 1)
}
.line-status-fail  path.line {
  stroke:  transparentize( $red-red, 0.5);
}
#gradient-fail .stop1 {
	stop-color: transparentize( $red-red, 0.8)
}
#gradient-fail .stop2 {
	stop-color: transparentize( $red-red, 1)
}


.line-status-success  circle, .status-success  .value {
  fill: $forest-green;
  color:  $forest-green;
  
  
}
.line-status-halfwin  circle, .status-halfwin  .value {
  fill: $forest-green-light;
  color:  $forest-green-light;
  
}
.line-status-void  circle, .status-void  .value {
  fill: $orange;
  color:  $orange;
  
}
.line-status-halfloss  circle, .status-halfloss  .value {
  fill: $light-red;
  color:  $light-red;
  
}
.line-status-fail  circle, .status-fail  .value {
  fill: $red-red;
  color:  $red-red;
}


.dark .status-success  .main-value {
  color: white;
  background: $forest-green;
  @apply rounded px-3;
  
}
.dark .status-halfwin  .main-value {
  color: white;
  background: $forest-green-light;
  @apply rounded px-3;
  
}
.dark .status-void  .main-value {
  color: white;
  background: $orange;
  @apply rounded px-3;
  
}
.dark .status-halfloss  .main-value {
  color: white;
  background: $light-red;
  @apply rounded px-3;
  
}
.dark .status-fail  .main-value {
  color: white;
  background: $red-red;
  @apply rounded px-3;
}
.dark .value {
  color:white;
}

.percent {
   text-anchor: start;
   dominant-baseline:hanging;
   font-size:0.6rem;
   fill: rgba(102,115,127,1);
}
</style>